/**
 * Maps a live stream status string to a StatusPill tone.
 * Single source of truth — used by CurrentJobsList, CurrentJobDetail,
 * RecentJobsCard, and JobMonitorPanel (WS stream-status display).
 *
 * Tone decisions:
 *   success  → actively streaming / publishing / running
 *   danger   → forbidden / interrupted / error (requires operator action)
 *   warning  → timed out / expired (transient / resource exhaustion)
 *   info     → to be started (idle, waiting)
 *   muted    → ended (terminal, no action needed)
 *   neutral  → unknown / unrecognized
 */
export type StreamStatusTone = 'success' | 'danger' | 'warning' | 'info' | 'neutral' | 'muted';

export function streamStatusTone(status?: string | null): StreamStatusTone {
  const s = (status ?? '').toLowerCase();
  if (s === 'running' || s === 'streaming' || s === 'publishing' || s === 'connected') return 'success';
  if (s === 'forbidden' || s === 'interrupted' || s === 'error') return 'danger';
  if (s === 'timeouted' || s === 'timed out' || s === 'expired' || s === 'disconnected' || s === 'unpublished') return 'warning';
  if (s === 'to be started') return 'info';
  if (s === 'ended') return 'muted';
  return 'neutral';
}
